// removed by extract-text-webpack-plugin
module.exports = {"review-container":"_2IiB1rs7iE5xgS7mH3yoYX","reviewer":"_1_7EkspJ0zpHLVIZQF7EKD","reviewer-pic":"_2hVlwpnWPWcDmH0eLFNFWr","review-content":"_2E3yKFWx7nWeIg0N7QCD_Z","reviewer-name":"HWEdO6G63DkzuWswvV46o","review-p":"_25YGmKP4AysX6oEIRMJSFY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/ZHReview.scss
// module id = 253
// module chunks = 0 2 9